module.exports = __webpack_public_path__ + "img/icon_2_38.617e6a81.png";